import { state } from './models';
import { getters } from './getters';
import * as actions from './actions';
import { mutations } from './mutations';

export const userManagerModule = {
  state,
  getters,
  actions,
  mutations
};
